module.exports = __webpack_public_path__ + "img/Product_titel_mikoto.eeeb4568.png";